import React, { FunctionComponent } from 'react';
import './e-warrant-key-value-grid.scss';

export const NOT_AVAILABLE = '—';

export type EWarrantKeyValueItem = {
  label: string
  value?: string | null
  isMonospaced?: boolean
  /** Overrides `value` with a custom node, e.g. a status chip. */
  renderValue?: () => React.ReactNode
};

type Props = {
  items: EWarrantKeyValueItem[]
};

const EWarrantKeyValueGrid: FunctionComponent<Props> = ({ items }: Props) => (
  <div className="e-warrant-key-value-grid" data-testid="EWarrantKeyValueGrid">
    {items.map(({
      label, value, isMonospaced, renderValue
    }) => (
      <div className="e-warrant-key-value-item" key={label}>
        <span className="e-warrant-key-value-label">{label}</span>
        <span className={`e-warrant-key-value-value${isMonospaced ? ' monospaced' : ''}`}>
          {renderValue ? renderValue() : (value == null || value === '' ? NOT_AVAILABLE : value)}
        </span>
      </div>
    ))}
  </div>
);

export default EWarrantKeyValueGrid;
